export enum SystemProcessHomeTabs {
  ALL = '-1',
  DRAFT = '0',
  SUBMITTED = '1',
}

export enum ApprovalTabs {
  ALL = 'All',
  PENDING = 'Pending',
  APPROVED = 'Approved',
  HOLD = 'Hold',
  REJECTED = 'Rejected',
}

export enum TravelClaimTabs {
  ALL = 'all',
  REQUEST = 'request',
  CLAIM = 'claim',
}
